import { Box, Container, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackdropLoader from '../../components/BackdropLoader.jsx';
import { api } from '../../utils/apiFunctions';

const FirstGoalPDF = ({ peopleBuilder }) => {
    const [openBackdrop, setOpenBackdrop] = useState(true)
    const [url, setUrl] = useState('')
    const navigate = useNavigate()

    const getUserPeopleBuilderSettings = async () => {

        try {
            const response = await api.get('/people-builder-settings')
            const values = response.data.filter(value => value.status === 'active')

            if (values.length) {
                setUrl(values[0].file_url)
            }

            setOpenBackdrop(false)

        } catch (error) {
            console.log(error)
            setOpenBackdrop(false)
        }
    }

    const handleIframeLoad = () => {
        setOpenBackdrop(false)
    }

    useEffect(() => {
        getUserPeopleBuilderSettings()
    }, [])

    return (
        <Container>
            {openBackdrop && (
                <BackdropLoader openBackdrop={openBackdrop} />
            )}
            <Box sx={{ backgroundColor: 'grey' }}>
                <Typography
                    sx={{ textAlign: 'center', p: 1 }}
                    variant='h5'
                >
                    People Builder Goals Setting
                </Typography>
            </Box>
            <Paper sx={{ height: '70vh' }} elevation={2}>
                <iframe style={{
                    width: '-webkit-fill-available',
                    height: '-webkit-fill-available'
                }}
                    src={url}
                    onLoad={handleIframeLoad}
                />
            </Paper>

        </Container>
    );
};

export default FirstGoalPDF;